<template>
  <div id="app">
    <nav>
      <div class="nav__item">
        <router-link class="nav__link" to="/">
          <svg
            class="home"
            width="15"
            height="15"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="nav__img"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.4836 17.3332H5.51639C3.59244 17.3332 2.03277 15.8448 2.03277 14.0088V9.94404C2.03277 9.35385 1.78708 8.78783 1.34976 8.3705C0.336525 7.40359 0.468245 5.80154 1.62711 4.99727L6.95105 1.30233C8.17259 0.454561 9.82745 0.454561 11.049 1.30233L16.3729 4.99727C17.5318 5.80154 17.6635 7.40359 16.6503 8.3705C16.213 8.78783 15.9673 9.35385 15.9673 9.94404V14.0088C15.9673 15.8448 14.4076 17.3332 12.4836 17.3332ZM7.33335 13.3748C6.98818 13.3748 6.70835 13.6547 6.70835 13.9998C6.70835 14.345 6.98818 14.6248 7.33335 14.6248H10.6667C11.0119 14.6248 11.2917 14.345 11.2917 13.9998C11.2917 13.6547 11.0119 13.3748 10.6667 13.3748H7.33335Z"
              fill="#828991"
            />
          </svg>

          <p class="nav__text">Главная</p>
        </router-link>
      </div>
      <div class="nav__item">
        <router-link class="nav__link" to="/handbook">
          <svg
            class="nav__img"
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.75 4.04447C10.75 3.63026 10.4142 3.29447 9.99996 3.29447C9.58575 3.29447 9.24996 3.63026 9.24996 4.04447H10.75ZM9.24996 15.9187C9.24996 16.333 9.58575 16.6687 9.99996 16.6687C10.4142 16.6687 10.75 16.333 10.75 15.9187H9.24996ZM3.32857 1.50939L3.41278 0.764136L3.32857 1.50939ZM9.43065 3.52037L9.86104 2.90616L9.86104 2.90616L9.43065 3.52037ZM3.32857 14.3103L3.41278 13.565L3.32857 14.3103ZM9.43065 16.3212L9.86104 15.707L9.86104 15.707L9.43065 16.3212ZM16.6714 1.50939L16.5871 0.764136L16.6714 1.50939ZM10.5693 3.52037L10.1389 2.90616V2.90616L10.5693 3.52037ZM16.6714 14.3103L16.5871 13.565L16.6714 14.3103ZM10.5693 16.3212L10.1389 15.707L10.1389 15.707L10.5693 16.3212ZM4.28141 5.1377C3.87208 5.07431 3.48885 5.35475 3.42546 5.76408C3.36207 6.17342 3.64251 6.55664 4.05184 6.62003L4.28141 5.1377ZM7.22945 7.43941C7.61579 7.58881 8.05008 7.39673 8.19948 7.0104C8.34887 6.62407 8.1568 6.18977 7.77046 6.04038L7.22945 7.43941ZM4.28141 8.47103C3.87208 8.40764 3.48885 8.68808 3.42546 9.09742C3.36207 9.50675 3.64251 9.88997 4.05184 9.95336L4.28141 8.47103ZM5.64982 10.2758C6.05145 10.3772 6.45918 10.1337 6.5605 9.7321C6.66183 9.33048 6.41839 8.92275 6.01677 8.82142L5.64982 10.2758ZM9.24996 4.04447V15.9187H10.75V4.04447H9.24996ZM3.24435 2.25465C5.05097 2.4588 7.38455 3.00242 9.00025 4.13459L9.86104 2.90616C7.93725 1.55811 5.30345 0.97778 3.41278 0.764136L3.24435 2.25465ZM3.24435 15.0555C5.05097 15.2597 7.38455 15.8033 9.00025 16.9355L9.86104 15.707C7.93725 14.359 5.30345 13.7787 3.41278 13.565L3.24435 15.0555ZM0.916626 3.11265V12.5H2.41663V3.11265H0.916626ZM3.41278 13.565C2.84599 13.501 2.41663 13.0305 2.41663 12.5H0.916626C0.916626 13.8547 1.9813 14.9128 3.24435 15.0555L3.41278 13.565ZM3.41278 0.764136C1.98376 0.602658 0.916626 1.79528 0.916626 3.11265H2.41663C2.41663 2.54475 2.84353 2.20936 3.24435 2.25465L3.41278 0.764136ZM16.5871 0.764136C14.6965 0.97778 12.0627 1.55811 10.1389 2.90616L10.9997 4.13459C12.6154 3.00242 14.9489 2.4588 16.7556 2.25465L16.5871 0.764136ZM16.5871 13.565C14.6965 13.7787 12.0627 14.359 10.1389 15.707L10.9997 16.9355C12.6154 15.8033 14.9489 15.2597 16.7556 15.0555L16.5871 13.565ZM17.5833 3.11265V12.5H19.0833V3.11265H17.5833ZM16.7556 15.0555C18.0186 14.9128 19.0833 13.8547 19.0833 12.5H17.5833C17.5833 13.0305 17.1539 13.501 16.5871 13.565L16.7556 15.0555ZM16.7556 2.25465C17.1564 2.20936 17.5833 2.54475 17.5833 3.11265H19.0833C19.0833 1.79528 18.0162 0.602658 16.5871 0.764136L16.7556 2.25465ZM9.00025 16.9355C9.59875 17.3548 10.4012 17.3548 10.9997 16.9355L10.1389 15.707C10.0571 15.7643 9.9428 15.7643 9.86104 15.707L9.00025 16.9355ZM9.00025 4.13459C9.59875 4.55397 10.4012 4.55397 10.9997 4.13459L10.1389 2.90616C10.0571 2.96345 9.9428 2.96345 9.86104 2.90616L9.00025 4.13459ZM4.05184 6.62003C5.06966 6.77766 6.19118 7.03791 7.22945 7.43941L7.77046 6.04038C6.60504 5.5897 5.37322 5.30679 4.28141 5.1377L4.05184 6.62003ZM4.05184 9.95336C4.5645 10.0328 5.10538 10.1385 5.64982 10.2758L6.01677 8.82142C5.42171 8.67129 4.83456 8.5567 4.28141 8.47103L4.05184 9.95336Z"
              fill="#828991"
            />
          </svg>
          <p class="nav__text">Справочник</p>
        </router-link>
      </div>
      <div class="nav__item">
        <router-link class="nav__link" to="/feed">
          <svg
            class="nav__img"
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.2688 17.5299L14.0148 18.2356L14.2688 17.5299ZM12.9673 17.0614L13.2214 16.3557H13.2214L12.9673 17.0614ZM11.7189 17.1097L11.4111 16.4257L11.4111 16.4257L11.7189 17.1097ZM9.68394 18.0254L9.37617 17.3415L9.68394 18.0254ZM8.31606 18.0254L8.62383 17.3415H8.62383L8.31606 18.0254ZM6.28115 17.1097L6.58892 16.4257L6.58892 16.4257L6.28115 17.1097ZM5.03267 17.0614L4.77863 16.3557L4.77863 16.3557L5.03267 17.0614ZM3.7312 17.5299L3.98524 18.2356H3.98524L3.7312 17.5299ZM5.66667 5.08317C5.25245 5.08317 4.91667 5.41896 4.91667 5.83317C4.91667 6.24738 5.25245 6.58317 5.66667 6.58317V5.08317ZM9 6.58317C9.41421 6.58317 9.75 6.24738 9.75 5.83317C9.75 5.41896 9.41421 5.08317 9 5.08317V6.58317ZM5.66667 8.4165C5.25245 8.4165 4.91667 8.75229 4.91667 9.1665C4.91667 9.58072 5.25245 9.9165 5.66667 9.9165V8.4165ZM12.3333 9.9165C12.7475 9.9165 13.0833 9.58072 13.0833 9.1665C13.0833 8.75229 12.7475 8.4165 12.3333 8.4165V9.9165ZM5.66667 11.7498C5.25245 11.7498 4.91667 12.0856 4.91667 12.4998C4.91667 12.9141 5.25245 13.2498 5.66667 13.2498V11.7498ZM12.3333 13.2498C12.7475 13.2498 13.0833 12.9141 13.0833 12.4998C13.0833 12.0856 12.7475 11.7498 12.3333 11.7498V13.2498ZM3.16667 2.4165H14.8333V0.916504H3.16667V2.4165ZM15.75 3.33317V15.9618H17.25V3.33317H15.75ZM14.5228 16.8243L13.2214 16.3557L12.7133 17.7671L14.0148 18.2356L14.5228 16.8243ZM11.4111 16.4257L9.37617 17.3415L9.99172 18.7093L12.0266 17.7936L11.4111 16.4257ZM8.62383 17.3415L6.58892 16.4257L5.97337 17.7936L8.00828 18.7093L8.62383 17.3415ZM4.77863 16.3557L3.47716 16.8243L3.98524 18.2356L5.28671 17.7671L4.77863 16.3557ZM2.25 15.9618V3.33317H0.75V15.9618H2.25ZM3.47716 16.8243C2.8798 17.0393 2.25 16.5967 2.25 15.9618H0.75C0.75 17.6356 2.41039 18.8025 3.98524 18.2356L3.47716 16.8243ZM6.58892 16.4257C6.01739 16.1686 5.36831 16.1435 4.77863 16.3557L5.28671 17.7671C5.51038 17.6866 5.75659 17.6961 5.97337 17.7936L6.58892 16.4257ZM9.37617 17.3415C9.13694 17.4491 8.86306 17.4491 8.62383 17.3415L8.00828 18.7093C8.63897 18.9931 9.36103 18.9931 9.99172 18.7093L9.37617 17.3415ZM13.2214 16.3557C12.6317 16.1435 11.9826 16.1686 11.4111 16.4257L12.0266 17.7936C12.2434 17.6961 12.4896 17.6866 12.7133 17.7671L13.2214 16.3557ZM15.75 15.9618C15.75 16.5967 15.1202 17.0393 14.5228 16.8243L14.0148 18.2356C15.5896 18.8025 17.25 17.6356 17.25 15.9618H15.75ZM14.8333 2.4165C15.3396 2.4165 15.75 2.82691 15.75 3.33317H17.25C17.25 1.99848 16.168 0.916504 14.8333 0.916504V2.4165ZM3.16667 0.916504C1.83198 0.916504 0.75 1.99848 0.75 3.33317H2.25C2.25 2.82691 2.66041 2.4165 3.16667 2.4165V0.916504ZM5.66667 6.58317H9V5.08317H5.66667V6.58317ZM5.66667 9.9165H12.3333V8.4165H5.66667V9.9165ZM5.66667 13.2498H12.3333V11.7498H5.66667V13.2498Z"
              fill="#828991"
            />
          </svg>
          <p class="nav__text">Лента</p>
        </router-link>
      </div>
      <div class="nav__item">
        <router-link class="nav__link" to="/jobs">
          <svg
            class="nav__img"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.91666 5.00001C5.91666 5.41422 6.25244 5.75 6.66666 5.75C7.08087 5.75 7.41666 5.41422 7.41666 5.00001H5.91666ZM12.5833 5.00001C12.5833 5.41422 12.9191 5.75 13.3333 5.75C13.7475 5.75 14.0833 5.41422 14.0833 5.00001H12.5833ZM2.08244 7.99871C1.7377 7.76908 1.27209 7.86239 1.04246 8.20712C0.812827 8.55186 0.906138 9.01748 1.25087 9.24711L2.08244 7.99871ZM18.7491 9.24711C19.0938 9.01748 19.1872 8.55186 18.9575 8.20712C18.7279 7.86239 18.2623 7.76908 17.9175 7.99871L18.7491 9.24711ZM8.24001 11.5053C8.65217 11.5466 9.01973 11.2459 9.06098 10.8338C9.10224 10.4216 8.80156 10.054 8.38941 10.0128L8.24001 11.5053ZM11.6106 10.0128C11.1984 10.054 10.8977 10.4216 10.939 10.8338C10.9802 11.2459 11.3478 11.5466 11.76 11.5053L11.6106 10.0128ZM4.99999 5.75H15V4.25001H4.99999V5.75ZM17.5833 8.33334V15H19.0833V8.33334H17.5833ZM15 17.5833H4.99999V19.0833H15V17.5833ZM2.41666 15V8.33334H0.916656V15H2.41666ZM4.99999 17.5833C3.57325 17.5833 2.41666 16.4267 2.41666 15H0.916656C0.916656 17.2552 2.74483 19.0833 4.99999 19.0833V17.5833ZM17.5833 15C17.5833 16.4267 16.4267 17.5833 15 17.5833V19.0833C17.2552 19.0833 19.0833 17.2552 19.0833 15H17.5833ZM15 5.75C16.4267 5.75 17.5833 6.9066 17.5833 8.33334H19.0833C19.0833 6.07818 17.2552 4.25001 15 4.25001V5.75ZM4.99999 4.25001C2.74483 4.25001 0.916656 6.07818 0.916656 8.33334H2.41666C2.41666 6.9066 3.57325 5.75 4.99999 5.75V4.25001ZM7.41666 5.00001V4.16667H5.91666V5.00001H7.41666ZM9.16666 2.41667H10.8333V0.916672H9.16666V2.41667ZM12.5833 4.16667V5.00001H14.0833V4.16667H12.5833ZM10.8333 2.41667C11.7998 2.41667 12.5833 3.20017 12.5833 4.16667H14.0833C14.0833 2.37175 12.6282 0.916672 10.8333 0.916672V2.41667ZM7.41666 4.16667C7.41666 3.20017 8.20016 2.41667 9.16666 2.41667V0.916672C7.37173 0.916672 5.91666 2.37175 5.91666 4.16667H7.41666ZM1.66666 8.62291C1.25087 9.24711 1.25107 9.24724 1.25128 9.24737C1.25136 9.24743 1.25157 9.24757 1.25174 9.24768C1.25207 9.2479 1.25244 9.24815 1.25284 9.24842C1.25366 9.24896 1.25464 9.2496 1.25578 9.25035C1.25805 9.25185 1.26096 9.25376 1.26451 9.25608C1.2716 9.2607 1.28123 9.26694 1.29336 9.27468C1.31763 9.29016 1.35191 9.31169 1.39592 9.33852C1.48394 9.39215 1.61098 9.46701 1.77479 9.55701C2.10229 9.73693 2.5776 9.97785 3.18268 10.2309C4.39178 10.7366 6.12656 11.2938 8.24001 11.5053L8.38941 10.0128C6.45318 9.81898 4.86393 9.30812 3.76142 8.84704C3.2107 8.61673 2.78332 8.39962 2.49706 8.24235C2.354 8.16375 2.24641 8.10022 2.17651 8.05762C2.14156 8.03633 2.11607 8.02028 2.10029 8.01021C2.0924 8.00518 2.08695 8.00164 2.08396 7.99969C2.08247 7.99872 2.08159 7.99814 2.08133 7.99797C2.08121 7.99789 2.08123 7.99791 2.08142 7.99803C2.08151 7.99809 2.08164 7.99818 2.08181 7.99829C2.0819 7.99835 2.08205 7.99845 2.0821 7.99848C2.08226 7.99859 2.08244 7.99871 1.66666 8.62291ZM11.76 11.5053C13.8734 11.2938 15.6082 10.7366 16.8173 10.2309C17.4224 9.97785 17.8977 9.73693 18.2252 9.55701C18.389 9.46701 18.516 9.39215 18.6041 9.33852C18.6481 9.31169 18.6824 9.29016 18.7066 9.27468C18.7187 9.26694 18.7284 9.2607 18.7355 9.25608C18.739 9.25376 18.7419 9.25185 18.7442 9.25035C18.7453 9.2496 18.7463 9.24896 18.7471 9.24842C18.7475 9.24815 18.7479 9.2479 18.7482 9.24768C18.7484 9.24757 18.7486 9.24743 18.7487 9.24738C18.7489 9.24724 18.7491 9.24711 18.3333 8.62291C17.9175 7.99871 17.9177 7.99859 17.9179 7.99848C17.9179 7.99845 17.9181 7.99835 17.9182 7.99829C17.9183 7.99818 17.9185 7.99809 17.9186 7.99803C17.9187 7.99791 17.9188 7.99789 17.9186 7.99797C17.9184 7.99814 17.9175 7.99872 17.916 7.99969C17.913 8.00164 17.9076 8.00518 17.8997 8.01021C17.8839 8.02028 17.8584 8.03633 17.8235 8.05762C17.7536 8.10022 17.646 8.16375 17.5029 8.24235C17.2167 8.39962 16.7893 8.61673 16.2386 8.84704C15.136 9.30812 13.5468 9.81898 11.6106 10.0128L11.76 11.5053Z"
              fill="#828991"
            />
          </svg>
          <p class="nav__text">Работа</p>
        </router-link>
      </div>
      <div class="nav__item">
        <router-link class="nav__link" to="/contacts">
          <svg
            class="nav__img"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5 12.3333L11.3529 13.0688C11.6846 13.1351 12.0196 12.9713 12.1708 12.6687L11.5 12.3333ZM5.66667 6.5L5.33126 5.82918C5.02875 5.98043 4.8649 6.31544 4.93123 6.64709L5.66667 6.5ZM5.96168 6.35249L6.29709 7.02331L5.96168 6.35249ZM6.76379 4.2428L7.46014 3.96425L6.76379 4.2428ZM6.08574 2.54768L5.38938 2.82623V2.82623L6.08574 2.54768ZM15.4523 11.9143L15.1738 12.6106L15.4523 11.9143ZM13.7572 11.2362L14.0357 10.5399L13.7572 11.2362ZM11.6475 12.0383L12.3183 12.3737L12.3183 12.3737L11.6475 12.0383ZM12.4167 8.16667C12.4167 8.58088 12.7525 8.91667 13.1667 8.91667C13.5809 8.91667 13.9167 8.58088 13.9167 8.16667H12.4167ZM12.9129 6.89105L13.6058 6.60404V6.60404L12.9129 6.89105ZM11.1089 5.08707L11.396 4.39416L11.1089 5.08707ZM9.83333 4.08333C9.41912 4.08333 9.08333 4.41912 9.08333 4.83333C9.08333 5.24755 9.41912 5.58333 9.83333 5.58333V4.08333ZM15.75 8.16667C15.75 8.58088 16.0858 8.91667 16.5 8.91667C16.9142 8.91667 17.25 8.58088 17.25 8.16667H15.75ZM15.9925 5.61544L16.6854 5.32843L15.9925 5.61544ZM12.3846 2.00747L12.6716 1.31456V1.31456L12.3846 2.00747ZM9.83333 0.75C9.41912 0.75 9.08333 1.08579 9.08333 1.5C9.08333 1.91421 9.41912 2.25 9.83333 2.25V0.75ZM15.75 13.4617V14.8333H17.25V13.4617H15.75ZM3.16667 2.25H4.53828V0.75H3.16667V2.25ZM11.5 12.3333C11.6471 11.5979 11.6473 11.5979 11.6475 11.598C11.6476 11.598 11.6478 11.598 11.6479 11.5981C11.6481 11.5981 11.6483 11.5981 11.6485 11.5982C11.6488 11.5982 11.649 11.5983 11.6491 11.5983C11.6493 11.5983 11.649 11.5983 11.6482 11.5981C11.6467 11.5978 11.6432 11.5971 11.6379 11.5959C11.6272 11.5935 11.6092 11.5894 11.5845 11.5834C11.535 11.5714 11.4586 11.5516 11.3601 11.5227C11.1627 11.4646 10.8787 11.3701 10.5454 11.2273C9.87542 10.9402 9.02725 10.4666 8.28033 9.71967L7.21967 10.7803C8.13942 11.7001 9.16625 12.2682 9.95456 12.606C10.3504 12.7757 10.6914 12.8895 10.9368 12.9617C11.0597 12.9978 11.1591 13.0237 11.23 13.0409C11.2654 13.0496 11.2938 13.056 11.3145 13.0606C11.3249 13.0629 11.3333 13.0647 11.3397 13.066C11.3429 13.0667 11.3456 13.0673 11.3478 13.0677C11.3489 13.068 11.3499 13.0682 11.3508 13.0683C11.3512 13.0684 11.3516 13.0685 11.3519 13.0686C11.3521 13.0686 11.3524 13.0687 11.3524 13.0687C11.3527 13.0687 11.3529 13.0688 11.5 12.3333ZM8.28033 9.71967C7.53341 8.97275 7.05984 8.12458 6.77269 7.45456C6.62985 7.12127 6.53537 6.83726 6.47734 6.63994C6.44837 6.54144 6.42863 6.46505 6.41658 6.41551C6.41055 6.39076 6.40647 6.37276 6.40412 6.36211C6.40294 6.35679 6.4022 6.35331 6.40187 6.35175C6.40171 6.35098 6.40165 6.35068 6.40169 6.35087C6.40171 6.35096 6.40175 6.35118 6.40182 6.35152C6.40186 6.35169 6.4019 6.35189 6.40194 6.35212C6.40197 6.35224 6.40201 6.35244 6.40202 6.35249C6.40206 6.3527 6.4021 6.35291 5.66667 6.5C4.93123 6.64709 4.93128 6.64732 4.93132 6.64755C4.93134 6.64764 4.93139 6.64789 4.93143 6.64807C4.9315 6.64843 4.93158 6.64882 4.93166 6.64924C4.93184 6.65009 4.93204 6.65106 4.93226 6.65217C4.93271 6.65437 4.93328 6.65709 4.93395 6.6603C4.9353 6.66673 4.93711 6.67515 4.93939 6.68549C4.94396 6.70618 4.95045 6.73457 4.95907 6.77004C4.97632 6.84094 5.00215 6.94033 5.03829 7.06319C5.11046 7.30857 5.22431 7.64956 5.39397 8.04544C5.73182 8.83375 6.29992 9.86058 7.21967 10.7803L8.28033 9.71967ZM6.00208 7.17082L6.29709 7.02331L5.62627 5.68167L5.33126 5.82918L6.00208 7.17082ZM7.46014 3.96425L6.7821 2.26914L5.38938 2.82623L6.06743 4.52134L7.46014 3.96425ZM15.7309 11.2179L14.0357 10.5399L13.4787 11.9326L15.1738 12.6106L15.7309 11.2179ZM10.9767 11.7029L10.8292 11.9979L12.1708 12.6687L12.3183 12.3737L10.9767 11.7029ZM14.0357 10.5399C12.8688 10.0731 11.5388 10.5787 10.9767 11.7029L12.3183 12.3737C12.5315 11.9473 13.036 11.7555 13.4787 11.9326L14.0357 10.5399ZM6.29709 7.02331C7.42128 6.46122 7.92694 5.13124 7.46014 3.96425L6.06743 4.52134C6.24449 4.96399 6.05269 5.46846 5.62627 5.68167L6.29709 7.02331ZM4.53828 2.25C4.91311 2.25 5.25017 2.47821 5.38938 2.82623L6.7821 2.26914C6.41509 1.35163 5.52647 0.75 4.53828 0.75V2.25ZM17.25 13.4617C17.25 12.4735 16.6484 11.5849 15.7309 11.2179L15.1738 12.6106C15.5218 12.7498 15.75 13.0869 15.75 13.4617H17.25ZM14.8333 15.75C7.88375 15.75 2.25 10.1162 2.25 3.16667H0.75C0.75 10.9447 7.05532 17.25 14.8333 17.25V15.75ZM14.8333 17.25C16.168 17.25 17.25 16.168 17.25 14.8333H15.75C15.75 15.3396 15.3396 15.75 14.8333 15.75V17.25ZM2.25 3.16667C2.25 2.66041 2.66041 2.25 3.16667 2.25V0.75C1.83198 0.75 0.75 1.83198 0.75 3.16667H2.25ZM13.9167 8.16667C13.9167 7.63044 13.811 7.09946 13.6058 6.60404L12.22 7.17807C12.3498 7.49149 12.4167 7.82742 12.4167 8.16667H13.9167ZM13.6058 6.60404C13.4006 6.10863 13.0999 5.65849 12.7207 5.27931L11.66 6.33997C11.8999 6.57986 12.0902 6.86464 12.22 7.17807L13.6058 6.60404ZM12.7207 5.27931C12.3415 4.90014 11.8914 4.59937 11.396 4.39416L10.8219 5.77998C11.1354 5.9098 11.4201 6.10009 11.66 6.33997L12.7207 5.27931ZM11.396 4.39416C10.9005 4.18895 10.3696 4.08333 9.83333 4.08333V5.58333C10.1726 5.58333 10.5085 5.65015 10.8219 5.77998L11.396 4.39416ZM17.25 8.16667C17.25 7.1927 17.0582 6.22826 16.6854 5.32843L15.2996 5.90246C15.597 6.6203 15.75 7.38968 15.75 8.16667H17.25ZM16.6854 5.32843C16.3127 4.4286 15.7664 3.61099 15.0777 2.92229L14.017 3.98295C14.5665 4.53236 15.0023 5.18461 15.2996 5.90246L16.6854 5.32843ZM15.0777 2.92229C14.389 2.23359 13.5714 1.68728 12.6716 1.31456L12.0975 2.70038C12.8154 2.99772 13.4676 3.43354 14.017 3.98295L15.0777 2.92229ZM12.6716 1.31456C11.7717 0.941838 10.8073 0.75 9.83333 0.75V2.25C10.6103 2.25 11.3797 2.40304 12.0975 2.70038L12.6716 1.31456Z"
              fill="#828991"
            />
          </svg>
          <p class="nav__text">Контакты</p>
        </router-link>
      </div>
    </nav>
    <router-view />
  </div>
</template>
<script>
import axios from "@/axios/axios.js";
// import { initializeApp } from "firebase/app";
export default {
  name: "ContactsView",
  components: {},
  created() {
    // const firebaseConfig = {
    //   apiKey: "AIzaSyDA0xh8OIfXg7liHEMM4FtZXkmLG6Xd7TY",
    //   authDomain: "hello-world-bf6ed.firebaseapp.com",
    //   projectId: "hello-world-bf6ed",
    //   storageBucket: "hello-world-bf6ed.appspot.com",
    //   messagingSenderId: "350483164460",
    //   appId: "1:350483164460:web:84c36dfa59ebdc7ee15089",
    // };
    // const app = initializeApp(firebaseConfig);
    // console.log(app);
    this.webSocket;
  },
  methods: {
    webSocket() {
      function processPush(message) {
        var data = message["type"];
        if (data["type"] == "hash") {
          // ТУТ НУЖНО открыть статью. идентификатор тут data['id']
          alert(data["id"]);
          // console.log(message, message["type"], message["id"]);
        }
      }

      function processToken(token) {
        // Делаем запрос на отправку токена бэку, чтобы он смог отправлять пуши данному пользователю
        axios.post(
          // "/index.php?route=api/firebase/setToken&api_token=6531f8ba",
          "api/cloud_messagings/",
          { token: token },
          function (_result) {
            // console.log(_result, token);
          }
        );
      }
      function initFirbase() {
        (async function () {
          // window._firebaseExists - ключ, который может появиться на странице в самом начале, если он есть - api firebase может появиться (оно появляетя асинхронно, и мы ждем его через setTimeout, а данный ключ нужен для оптимизации, чтобы js не работал вхолостую, если запрос не из приложения)
          if (!window._firebaseExists) {
            // Зашли не из приложения - ничего не делаем
            return;
          }
          function sleepPromise(ms) {
            return new Promise((r) => {
              setTimeout(r, ms);
            });
          }
          function waitFirebase(total, interval) {
            return new Promise(async (res, rej) => {
              while (true) {
                // По хорошему - желательно, сначала проверить наличие в циклие, только потом - спать или реджектить.
                // Спим interval ms
                await sleepPromise(interval);
                // Проверяем - появилось ли firebase
                if (typeof Firebase !== "undefined") {
                  // Появилось
                  return res();
                }
                // Отнимаем от общего ожидаемого времени, если время истекло - возвращаем reject, иначе - еще 1 итерация
                total -= interval;
                if (total < 0) {
                  return rej();
                }
              }
            });
          }
          try {
            // Ожидаем готовности api (2 секунды, с проверкой наличия, каждую секунду, потом, можно поднастроить)
            await waitFirebase(1000 * 2, 1000);
            console.log("Firebase ready!");
            console.log(waitFirebase);
          } catch (e) {
            // Не дождались api. Практически - такого не может быть, теоретически - возможно.
            console.log("Firebase wait timeouted!");
            return;
          }
          try {
            await Firebase.requestUserPermission();
          } catch (e) {
            return;
          }
          Firebase.getToken().then(processToken);
          Firebase.onTokenRefresh(processToken);
          Firebase.onMessage(processPush);
        })();
      }
      initFirbase();
    },
  },
};
</script>
<style>
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  padding: 15px;
}
nav {
  display: flex;
  justify-content: space-evenly;

  position: fixed;
  bottom: 10px;
  left: calc(50% - 160px);

  width: 320px;
  height: 56px;

  background-color: #ffffff;
  border-radius: 20px;
}
.nav__link {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-top: 9px;

  justify-content: space-evenly;
  align-items: center;
}
.nav__text {
  color: rgb(71, 68, 68);
  margin: 0;
  font-size: small;
  font-style: normal;
}
.nav__img {
  height: 16px;
}
body {
  padding: 0;
  margin: 0;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0 0 0 0);
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
a {
  text-decoration: none;
}
img {
  width: 100%;
  height: auto;
}
.router-link-exact-active > .nav__text {
  color: #c6890d;
}
.router-link-exact-active > .nav__img {
  stroke: #c6890d;
  fill: #c6890d;
}
.router-link-exact-active > .home > path {
  fill: #c6890d;
}
.v--modal-box {
  padding: 20px !important;
  box-sizing: border-box !important;
  padding-top: 30px !important;
  border-radius: 15px !important;
  height: auto !important;
}
.v--modal-box p {
  color: green !important;
  font-size: 24px !important;
  margin: 0px !important;
  text-align: center !important;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  
}
.v--modal-box p span {
  display: inline-block;
  margin-right: 8px;
  width: 40px;
  height: 40px;
  position: relative;
  top: 5px;
  margin-bottom: 10px;
}
.v--modal-box p span img {
  width: 100%;
}
</style>
